import {CustomCellRendererProps} from '@ag-grid-community/react';
import {IconClipboardCheck, IconShield, IconShieldFilled} from "@tabler/icons-react";
import {Group} from "@mantine/core";
import {RrcEp10WasteManifestBuildStatusEntity} from "@ots-frontend/ots-data";
import {useMemo} from "react";

export type IdData = {
  id?: string;
  dispatchMatch?: boolean
  rrcEp10WasteManifestBuildStatus?: RrcEp10WasteManifestBuildStatusEntity
}
export type IdCellProps = CustomCellRendererProps<IdData> & {}

export const IdCell = (props: IdCellProps) => {
  const {value} = props

  const dispatchIcon = useMemo(() => {
    if (value?.dispatchMatch) {
      return <IconClipboardCheck size={14}/>
    }

    return undefined
  }, [value?.dispatchMatch])

  const buildStatusIcon = useMemo(() => {
    const buildStatus = value?.rrcEp10WasteManifestBuildStatus
    if (buildStatus) {
      if (buildStatus.status === 'BLOCKED') {
        return <IconShieldFilled size={14} color="red" />
      } else if (buildStatus.status === 'GENERATED') {
        const warning = buildStatus.violations?.find(v => v.severity === 'WARN')
        if (warning) {
          return <IconShield size={14} color="orange" />
        } else {
          return <IconShield size={14} />
        }
      }
    }

    return undefined
  }, [value?.rrcEp10WasteManifestBuildStatus])

  if (!value) {
    return undefined
  }

  return (
    <Group spacing="xs">
      {dispatchIcon && dispatchIcon}
      {buildStatusIcon && buildStatusIcon}
      {value.id && value.id}
    </Group>
  )
}
